import {memo} from 'react'
import {Timeline, RelativeTime} from '@primer/react'
import type {TimelineItem} from '../../../page-data/payloads/timeline'
import {TimelineItemBadge} from './TimelineItemBadge'
import styles from './TimelineEvent.module.css'
import {Author} from '../../Author'
import {PullRequestReviewText} from './items/PullRequestReviewText'
import {PullRequestReviewAction} from './items/PullRequestReviewAction'
import {IssueEventText} from './items/IssueEventText'
import {PullRequestCommitText} from './items/PullRequestCommitText'
import {OtherItemText} from './items/OtherItemText'
import {IssueCommentAction} from './items/IssueCommentAction'
import {TimelineAvatar} from './TimelineAvatar'

// using a switch for better type narrowing
function ItemText({item}: {item: TimelineItem}) {
  switch (item.type) {
    case 'PullRequestReview':
      return <PullRequestReviewText item={item} />
    case 'PullRequestCommit':
      return <PullRequestCommitText item={item} />
    case 'IssueEvent':
      return <IssueEventText item={item} />
    default:
      return <OtherItemText item={item} />
  }
}

function ItemAction({item}: {item: TimelineItem}) {
  switch (item.type) {
    case 'PullRequestReview':
      return <PullRequestReviewAction item={item} />
    case 'IssueComment':
      return <IssueCommentAction item={item} />
    default:
      return null
  }
}

export const TimelineEvent = memo(function TimelineEvent({item}: {item: TimelineItem}) {
  return (
    <Timeline.Item condensed>
      <TimelineItemBadge item={item} />
      <Timeline.Body className="d-flex flex-row flex-justify-between flex-items-start">
        <span className="fgColor-muted">
          <TimelineAvatar user={item.user} /> <Author login={item.user?.displayLogin} /> <ItemText item={item} />
        </span>
        <span className="d-flex flex-row flex-items-center fgColor-muted">
          <ItemAction item={item} />
          <RelativeTime className={styles.timestamp} datetime={item.timestamp} format="micro" />
        </span>
      </Timeline.Body>
    </Timeline.Item>
  )
})
